import { useDispatch, useSelector } from "react-redux";
import actions from "../store/actions.js";

export default function useApiKey() {
  const dispatch = useDispatch();
  const { mobileConnectionInfo } = useSelector(state => state);

  const changeApiKey = value =>
    dispatch(
      actions.mobileConnection.changeConnectionData({
        ...mobileConnectionInfo,
        apiKey: value,
      })
    );

  return {
    changeApiKey,
  };
}
